import { topicIndex, navTopics } from "@/mocks/jiukanliao";
import SectionHeading from "./SectionHeading";

export default function TopicSection() {
  return (
    <section id="topics" className="relative overflow-hidden py-14 md:py-20">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_90%_10%,#f8e2c2_0%,transparent_48%)]" />
      <div className="relative mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="九宫格题材目录"
            title="想看哪一类，直接进哪一格"
            desc="九图吃瓜内容五花八门，按题材分格归档。点击板块即可直达该题材下的九宫格爆料、截图合集与多图预警图集。"
          />
          <div className="hidden shrink-0 items-center gap-2 md:flex">
            {navTopics.slice(0, 3).map((t) => (
              <a
                key={t.id}
                href="#topics"
                className="whitespace-nowrap rounded-full border border-[#e2cfaa] px-3.5 py-1.5 text-[13px] text-[#7a5c2e] transition hover:border-[#d9431f] hover:text-[#b43a17]"
              >
                {t.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {topicIndex.map((t) => (
            <a
              key={t.label}
              href="#alerts"
              className="group relative overflow-hidden rounded-2xl bg-white p-5 ring-1 ring-[#eadbc0] transition hover:-translate-y-0.5 hover:ring-[#d9b67a] md:p-6"
            >
              <span className="font-latin absolute -right-1 -top-4 text-6xl font-bold text-[#f4e7cf] transition group-hover:text-[#efd9b0]">
                {t.num}
              </span>
              <div className="relative flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#fff1e2] text-[#d9431f]">
                  <i className="ri-hashtag" />
                </span>
                <h3 className="font-display text-base font-bold text-[#231f18]">{t.label}</h3>
              </div>
              <p className="mt-3 text-[13px] leading-6 text-[#8a7a5d]">{t.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-[#f0e3ca] pt-3 text-[11px] text-[#a48a5d]">
                <span>{t.count} 图集</span>
                <span className="flex items-center gap-1 text-[#b43a17]">
                  进入板块
                  <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}